var DS3_Multistep = new Object();

DS3_Multistep.version = '1.0.0';
DS3_Multistep.$form = null;

DS3_Multistep.init = function ($form)
{
  this.$form = $form;

  var _parent = DS3;
  var $parentEl = _parent.$el;

  if ($parentEl[0].hasAttribute('data-multistep'))
  {
    $parentEl.attr('data-step', 1);

    // Insert Next button if not already present.
    if (!$form.find('.next-btn').length)
    {
      const $fieldsets = $form.children('fieldset');

      $('<button type="button" class="multistep-next-btn">Next</button>')
        .insertAfter($fieldsets.last());
    }

    // Tag fieldsets with their step (idempotent).
    let multiStepArrays = $parentEl[0].getAttribute('data-multistep').split(',');
    multiStepArrays.forEach((fields, i) =>
    {
      fields.split(' ').forEach(el =>
      {
        $form.find('input[name="' + el + '"]').closest('fieldset').addClass('step-' + (i + 1));
      });
    });

    $form.find('fieldset:not([class*=step-])').each(function ()
    {
      let lastStep = multiStepArrays.length + 1;
      $(this).closest('fieldset').addClass('step-' + lastStep);
    });

    // Next button — validates step 1 before advancing.
    // Delegated so it works even if HubSpot re-renders the form.
    $parentEl.on('click', 'button.multistep-next-btn', function (e)
    {
      e.preventDefault();
      const currStep = $parentEl.data('step');
      const $requiredFields = $form.find('fieldset.step-' + currStep).find('.input>[required]');
      if (helpers.shouldDebug('hsForm')) console.log('[DS3.Multistep] requiredFields:', $requiredFields);
      $requiredFields.focus();

      setTimeout(function ()
      {

        const hasErrors = $form.find('fieldset.step-' + currStep).find('.hs-error-msg').closest('.hs-form-field').length > 0;
        const nextStep = currStep + 1;
        if (hasErrors)
        {
          $parentEl.find('form fieldset.step-' + currStep + ' .hs-input.invalid, form fieldset.step-' + currStep + ' .hs-input.error').first().focus();
          return;
        }
        else
        {
          $parentEl.attr('data-step', nextStep);
        }
      }, 50);
    });

    // Clickable step indicators — only go back to completed steps, never after submit.
    $parentEl.on('click', '.step-indicator', function (e)
    {
      e.preventDefault();
      var clickedStep = parseInt($(this).data('step'));
      var currentStep = parseInt($parentEl.attr('data-step'));

      // Block navigation after form is submitted (step 3) — form is dead at that point.
      if (currentStep >= $parentEl.find('.step-indicator').length) return;

      if (clickedStep < currentStep)
      {
        $parentEl.attr('data-step', clickedStep);
      }
    });
  }
};

export default DS3_Multistep;